export default "__VITE_ASSET__DIljo$xj__"